import { Box, BoxProps } from '@mui/system'
import { theme } from 'theme'

type TColor = 'primary' | 'grey'
type TVariant = 'horizontal' | 'vertical'
interface Props {
  color?: TColor
  variant?: TVariant
  width?: string
  sx?: BoxProps
}
const CoreDivider = ({
  color = 'primary',
  variant = 'vertical',
  width,
  sx,
}: Props) => {
  const colors: Record<TColor, string> = {
    primary: theme.palette.primary.main,
    grey: '#D4D4D4',
  }

  return (
    <Box
      sx={{
        borderRight: `1px solid ${colors[color]}`,
        width: '0px',
        height: width ? width : '46px',
        transform: `rotate(${variant === 'vertical' ? 0 : 90}deg)`,
        ...sx,
      }}
    />
  )
}

export default CoreDivider
